// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseRequestFilterChips_root__jASgQ"};